import { addStructurePluginHandler } from './AddPluginStmt';
import { removeStructurePluginHandler } from './RemovePluginStmt';
export * from './AddPluginStmt';
export * from './RemovePluginStmt';
export const structurePluginHandlers = [addStructurePluginHandler, removeStructurePluginHandler];
//# sourceMappingURL=index.js.map